import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import ChatWidget from "@/components/ChatWidget";
import { Outlet } from "react-router-dom";

export default function Layout() {
    return (
        <div className="min-h-screen bg-[#ffffff]">
            <Header />
            <CartDrawer />
            <main className="pt-[92px] sm:pt-[108px]">
                <Outlet />
            </main>
            <Footer />
            <ChatWidget />
        </div>
    );
}
